import { PATH_NEW_DETAIL } from "@/constants/URL";
import routerWithSidebar from "../routerWithSidebar";
export default {
  path: PATH_NEW_DETAIL,
  components: routerWithSidebar(() =>
    import(/* webpackChunkName: "role" */ "@/views/detail/index.vue")
  )
};
